export default [
  {
    path: '/suppliers',
    name: 'suppliers',
    component: () => import('@/views/Suppliers/Index.vue'),
    meta: {
      pageTitle: 'Satıcı Kartları',
      breadcrumb: [
        {
          text: 'Satıcı Kartları',
          active: true,
        },
      ],
      resource: 'APP_SUPPLIERS',
      action: 'read',
    },
  },
  {
    path: '/suppliers/add',
    name: 'SuppliersAdd',
    component: () => import('@/views/Suppliers/Add.vue'),
    meta: {
      pageTitle: 'Satıcı Kartı Ekle',
      breadcrumb: [
        {
          text: 'Satıcı Kartları',
          to: '/suppliers',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
      resource: 'APP_SUPPLIER_ADD',
      action: 'read',
    },
  },
  {
    path: '/suppliers/edit/:id',
    name: 'SuppliersEdit',
    component: () => import('@/views/Suppliers/Edit.vue'),
    meta: {
      pageTitle: 'Satıcı Kartı Güncelle',
      breadcrumb: [
        {
          text: 'Satıcı Kartları',
          to: '/suppliers',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_SUPPLIER_EDIT',
      action: 'read',
    },
  },
  {
    path: '/suppliers/view/:id',
    name: 'SuppliersView',
    component: () => import('@/views/Suppliers/View.vue'),
    meta: {
      pageTitle: 'Satıcı Kartı Görüntüle',
      breadcrumb: [
        {
          text: 'Satıcı Kartları',
          to: '/suppliers',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'APP_SUPPLIER_VIEW',
      action: 'read',
    },
  },
]
